"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberToWordsMoney = void 0;
const numberFormatPad_1 = require("./numberFormatPad");
const numberRound_1 = require("./numberRound");
const numberToWords_1 = require("./numberToWords");
/**
 * tekst złotych
 * @param value liczba złotych
 */
function intText(value) {
    if (value === 1) {
        return 'złoty';
    }
    const decValue = value % 100;
    if (decValue >= 5 && decValue <= 20)
        return 'złotych';
    switch (decValue % 10) {
        case 2:
        case 3:
        case 4:
            return 'złote';
    }
    return 'złotych';
}
/**
 * tekst groszy
 * @param value liczba groszy
 */
function fracText(value) {
    if (value === 1) {
        return 'grosz';
    }
    const decValue = value % 100;
    if (decValue >= 5 && decValue <= 20)
        return 'groszy';
    switch (decValue % 10) {
        case 2:
        case 3:
        case 4:
            return 'grosze';
    }
    return 'groszy';
}
/**
 * Zamiana kwoty na słownie ze słowem złoty/ch
 * @param value kwota do zamiany
 * @param currency co wstawić jako walutę, domyslnie automatycznie dopasowuje odmianę `złoty`
 * @param forceShowGr czy wymusić grosze w przypadku gdy liczba groszy jest równa 0
 * @param showGrWords czy wyświetlać grosze słownie
 */
function numberToWordsMoney(value, currency = '', forceShowGr = false, showGrWords = false) {
    if (value < 0) {
        value = value * -1;
    }
    let strValue = '';
    const intValue = Math.floor(value);
    const fracValue = (0, numberRound_1.numberRound)((value - intValue) * 100, 0);
    if (!currency) {
        currency = intText(intValue);
    }
    strValue = (0, numberToWords_1.numberToWords)(intValue) + ' ' + currency;
    if (fracValue !== 0 || forceShowGr) {
        strValue += showGrWords
            ? ' ' + (0, numberToWords_1.numberToWords)(fracValue) + ' ' + fracText(fracValue)
            : ' ' + (0, numberFormatPad_1.numberFormatPad)(fracValue, 2) + '/100';
    }
    return strValue;
}
exports.numberToWordsMoney = numberToWordsMoney;
//# sourceMappingURL=numberToWordsMoney.js.map